export default __webpack_public_path__ + "static/media/customized.e0296b71.svg";